import React from "react";
import "../styles/whyus.css"; // ✅ reuse same styles
import pizzaIcon from "../assets/pizza-icon.svg";

const ORDER_URL = "https://debrecenipizza.hu/";

export default function Gyros() {
  return (
    <section className="whyus-section">
      <div className="container py-5">
        {/* Header text */}
        <div className="gyros-header">
          <h2>
            Ne hagyd, hogy a <span className="highlight-red">Pizza Home</span>{" "}
            neve megtévesszen – nemcsak finom{" "}
            <span className="highlight-red">pizzát Debrecenben,</span> hanem
            bőséges <span className="highlight-red">gyros tálakat</span> és édes{" "}
            <span className="highlight-red">óriáspalacsintákat</span> is házhoz
            szállítunk!
          </h2>
        </div>

        <div className="row align-items-center p-4 p-lg-0">
          {/* Right: Image */}
          <div className="col-lg-6 order-lg-2 p-lg-5">
            <div className="whyus-image-wrap pb-5 pb-lg-0">
              <img
                src="/images/gyros_section.webp"
                alt="Pizza Home gyros tál"
                className="whyus-image"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>

          {/* Left: Text */}
          <div className="col-lg-6 order-lg-1 p-lg-5">
            <div className="whyus-content">
              <h2>
                Miért olyan <span className="highlight">népszerű</span> a Pizza
                Home-os <span className="highlight">gyros Debrecenben?</span>
              </h2>

              <p>
                Beszállítóink folyamatosan biztosítják a jól bevált
                alapanyagokat, így nemcsak a pizzáink, hanem a gyrosok is
                gyakran rendeltek Debrecenben. Minden rendelésnél ugyanarra a
                megszokott, kiváló minőségre számíthatsz.
              </p>

              <ul className="whyus-list">
                <li>
                  <img src={pizzaIcon} alt="" className="icon" />A fűszeres sült
                  csirkehús, a ropogós hasábburgonya, az eredeti görög tzatziki,
                  a sült pita és a friss zöldségek együtt hozzák el neked a
                  mediterrán hangulatot Debrecenben.
                </li>
                <li>
                  <img src={pizzaIcon} alt="" className="icon" />
                  Alapértelmezés szerint lilahagymával és csípős öntettel
                  készítjük, de minden gyros tál személyre szabható – jelezd
                  rendeléskor, és pontosan úgy szállítjuk, ahogy szereted!
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="whyus-cta" style={{ textAlign: "center" }}>
          <a href={ORDER_URL} className="btn-order">
            Hamarosan &gt;&gt;
          </a>
        </div>
      </div>
    </section>
  );
}
